export default __webpack_public_path__ + "media/images/tresorerie-new-72e498a8c96cd0ea36eff6dcf5cd9ed2.png";